import moment from "moment";

export const moneda = (n: number): string =>
    n.toLocaleString("es-MX", { style: "currency", currency: "MXN" });

export const fecha = (valor: string): string =>
    valor ? moment(valor).format("DD-MM-YYYY") : "—";

export const textoOVacio = (valor: string): string => valor || "N/A";
